import { Component } from 'react'
import PropTypes from 'prop-types'

import MobileSearchBar from 'shared/mobile-search-bar'

import { isShortCode } from 'lib/short-codes'
import { storeShortCodePath, storeSearchResultsPath } from 'lib/urls'

export default class StoreMobileSearchBar extends Component {
  render() {
    return (
      <MobileSearchBar
        placeholder="Search store"
        onSubmit={this.handleSubmit}
      />
    )
  }

  handleSubmit = (searchText) => {
    if (isShortCode(searchText)) {
      window.location.href = blUrls.storeShortCodePath(searchText)
    } else {
      window.location.href = blUrls.storeSearchResultsPath(searchText)
    }
  }
}
